<template>
  <v-container
    class="ma-0 pa-0 white"
    fluid
    fill-height
  >
    <v-layout>
      <v-flex>
        <fullpage-loader
          message="טוען מתורגמנים..."
          v-if="!event"
        ></fullpage-loader>

        <translator
          :comp-id="compId"
          v-else-if="translatorId"
        />

        <div v-else>
          <v-data-table
            :headers="headers.filter(item => shouldShow(item.roles, user))"
            :items="translators"
            item-key="_id"
            hide-actions
            must-sort
          >
            <template v-slot:items="props">
              <td class="font-weight-bold"><a @click="showTranslator(props.item._id)">{{ props.item.name }}</a></td>
              <td class="text-xs-right">{{ languagesText(props.item) }}</td>
              <td
                class="text-xs-left"
                width="30"
                v-if="shouldShow(['ADMIN', 'EVENT_MANAGER'], user)"
              >
                <v-btn
                  small
                  icon
                  class="ml-0 mr-0 mt-1"
                  :loading="removing[props.item._id]"
                  @click="remove(props.item._id)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-btn
            small
            @click="add"
            class="mt-3"
            v-if="shouldShow(['ADMIN', 'EVENT_MANAGER'], user)"
          >
            <v-icon>add</v-icon> הוספת מתורגמן
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import FullpageLoader from "../../FullpageLoader.vue";
import Translator from "./Translators/Translator.vue";
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import { getApi } from "@/api";

export default {
  data() {
    return {
      loading: false,
      removing: {},
      compId: null,
      headers: [
        {
          text: "שם",
          align: "right",
          value: "name"
        },
        { text: "שפות", align: "right", value: "languages" },
        {
          text: "הסרה",
          align: "left",
          sortable: false,
          roles: ["ADMIN", "EVENT_MANAGER"]
        }
      ]
    };
  },

  computed: {
    translatorId() {
      return this.$store.getters["translators/activeTranslatorsIds"][this.compId];
    },
    event() {
      return this.$store.state.entities.events[this.eventId];
    },
    translators() {
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      const isAllEventsMode = eventIdsToShow && eventIdsToShow.length > 1;

      if (isAllEventsMode) {
        const allTranslators = [];
        const seenTranslatorIds = new Set();

        eventIdsToShow.forEach(eventId => {
          const event = this.$store.state.entities.events[eventId];
          if (event && event.translators) {
            event.translators.forEach(translatorId => {
              if (!seenTranslatorIds.has(translatorId)) {
                const translator = this.$store.state.entities.translators[translatorId];
                if (translator) {
                  allTranslators.push(translator);
                  seenTranslatorIds.add(translatorId);
                }
              }
            });
          }
        });

        return allTranslators;
      } else {
        if (this.event && this.event.translators) {
          return this.event.translators.map(item => {
            return this.$store.state.entities.translators[item];
          }).filter(Boolean);
        } else {
          return [];
        }
      }
    },
    activeTranslatorId: {
      get() {
        return this.$store.getters["translators/activeTranslatorsIds"][this.compId];
      },
      set(payload) {
        this.$store.commit("translators/SET_ACTIVE_TRANSLATOR_ID", {
          compId: this.compId,
          payload
        });
      }
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },
  methods: {
    shouldShow,
    languagesText(translator) {
      if (!translator || !translator.languages || !translator.languages.length) {
        return "לא ידוע";
      }
      return translator.languages.map(item => {
        let language = this.$store.state.entities.languages[item];
        return language ? language.title : null;
      }).filter(Boolean).join(", ") || "לא ידוע";
    },
    showTranslator(id) {
      this.activeTranslatorId = id;
    },
    add() {
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      const isAllEventsMode = eventIdsToShow && eventIdsToShow.length > 1;

      if (isAllEventsMode) {
        this.$store.commit("events/TOGGLE_EVENT_TRANSLATORS_DIALOG", true);
        this.$store.commit("events/SET_TRANSLATORS_FOR_ALL_EVENTS", {
          eventIds: eventIdsToShow
        });
      } else {
        this.$store.commit("events/TOGGLE_EVENT_TRANSLATORS_DIALOG", true);
      }
    },
    remove(translatorId) {
      this.$confirm("האם לבטל את הקישור של המתורגמן לאירוע?").then(res => {
        if (!res) {
          return;
        } else {
          this.removeConfirmed(translatorId);
        }
      });
    },
    removeConfirmed(translatorId) {
      let eventId = this.eventId;
      this.removing[translatorId] = true;
      getApi()
        .then(api => {
          let params = {
            translatorId
          };
          return api.patch(`/events/${eventId}/remove-translator`, params);
        })
        .then(data => {})
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.removing[translatorId] = false;
        });
    }
  },
  mounted() {
    this.compId = generateId();
  },

  watch: {
    '$store.state.events.eventIdsToShow': {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    },
    '$store.state.events.showAllEvents': {
      handler() {
        this.$forceUpdate();
      }
    },
    '$route.params.id': {
      handler(newEventId, oldEventId) {
        if (newEventId && newEventId !== oldEventId) {
          this.$forceUpdate();
        }
      },
      immediate: true
    }
  },

  props: ["eventId"],

  components: {
    FullpageLoader,
    Translator
  }
};
</script>



// WEBPACK FOOTER //
// src/components/events/modules/Translators.vue